// src/App.js
import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { MerchantProvider, useMerchant } from './context/MerchantContext';
import Login from './pages/Login';
import Orders from './pages/Orders';
import Products from './pages/Products';
import ShopSettings from './pages/ShopSettings';
import Earnings from './pages/Earnings';

const AppRoutes = () => {
  const { merchant, authLoading } = useMerchant();

  if (authLoading) return (
    <div style={{ minHeight: '100vh', background: '#0a0a0a', display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column', gap: 16 }}>
      <div style={{ fontSize: 48 }}>🏪</div>
      <div style={{ color: '#00d68f', fontWeight: 800, fontSize: 20 }}>MyTownly Merchant</div>
      <div className="spinner" />
    </div>
  );

  return (
    <Routes>
      <Route path="/login" element={!merchant ? <Login /> : <Navigate to="/" />} />
      <Route path="/" element={merchant ? <Orders /> : <Navigate to="/login" />} />
      <Route path="/products" element={merchant ? <Products /> : <Navigate to="/login" />} />
      <Route path="/settings" element={merchant ? <ShopSettings /> : <Navigate to="/login" />} />
      <Route path="/earnings" element={merchant ? <Earnings /> : <Navigate to="/login" />} />
    </Routes>
  );
};

export default function App() {
  return (
    <MerchantProvider>
      <BrowserRouter>
        <AppRoutes />
        <Toaster position="top-right" toastOptions={{
          style: { fontFamily: 'DM Sans, sans-serif', fontSize: 14, borderRadius: 12, background: '#1a1d24', color: '#e5e7eb', border: '1px solid #2a2d35' },
          success: { iconTheme: { primary: '#00d68f', secondary: '#0a0a0a' } },
        }} />
      </BrowserRouter>
    </MerchantProvider>
  );
}
